export default __webpack_public_path__ + "static/media/deer-tree-sprig-reverse.b5f8b073.png";